<template lang="pug">
v-layout(:class="{ 'pa-3' : !$vuetify.breakpoint.xsOnly}" fill-height)
  v-card.task(:class="{'full-height-desktop' : !$vuetify.breakpoint.xsOnly, 'full-height-mobile' : $vuetify.breakpoint.xsOnly }" width="100%")

    v-toolbar.v-toolbar-responsive.transparent(flat card)
      v-btn.my-0(:disabled="loading" icon @click="back")
        v-icon arrow_back
      v-toolbar-title.ml-0.task-toolbar-title
        v-avatar(size="40" v-if="!$vuetify.breakpoint.xsOnly")
          v-icon.white--text.process-default-icon
        ul(:class="{'pl-1' : $vuetify.breakpoint.xsOnly }")
          li(v-html="getTitle()")
          li(v-html="subtitle").body-2.grey--text.font-weight-thin          
      v-spacer
      div.hidden-xs-only.grey--text {{ task.created | moment().format("DD-MM-YYYY HH:mm") }}
      v-menu(bottom left)
        v-btn(slot="activator" icon)
          v-icon more_vert
        v-list
          v-list-tile(v-if="task.assignee === null" @click="claim")
            v-list-tile-action
              v-icon(color="green") done
            v-list-tile-content
              v-list-tile-title {{ $tf('task.claim') }}
          v-list-tile(v-if="task.assignee === profile.userName && canUnclaim" @click="unclaim")
            v-list-tile-action
              v-icon(color="red") clear
            v-list-tile-content
              v-list-tile-title {{ $tf('task.unclaim') }}
          v-list-tile(@click="diagram = true")
            v-list-tile-action
              v-icon(color="blue") timeline
            v-list-tile-content
              v-list-tile-title {{ $tf('task.showDiagram') }}
          v-list-tile(@click="selectProcess(task.processInstanceId)")
            v-list-tile-action
              v-icon(color="blue") history
            v-list-tile-content
              v-list-tile-title {{ $tf('task.showHistory') }}
          v-list-tile(v-if="businessKey" @click="copyBusinessKey")
            v-list-tile-action
              v-icon(color="blue") info
            v-list-tile-content
              v-list-tile-title {{ businessKey }}

    v-divider

    v-container.p-r(fluid grid-list-xl :class="[ !$vuetify.breakpoint.xsOnly ? 'pt-2' : 'pt-0' ]")
      v-btn.btn-center(v-if="task.assignee === null" ripple @click="claim" dark color="primary")
        v-icon(dark) check_box
        .ml-2 {{ $tf('task.claim') }}
      v-card-text(:class="{ 'px-0' : $vuetify.breakpoint.xsOnly }")
        .task-curtain(v-if="task.assignee !== profile.userName")
        slot
      v-card-actions
        slot(name="footer")

  wf-process-diagram(v-model="diagram" :taskDefinitionKey="task.taskDefinitionKey" :processDefinitionId="task.processDefinitionId" :processDefinitionName="processDefinitionName" :processVariables="variables")
  wf-process-info(ref="processInfo")
</template>

<script>
import lodash from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import ProcessDiagram from '@/components/process/ProcessDiagram'
import ProcessInfo from '@/components/process/ProcessInfo'

export default {
  name: 'TaskTemplate',

  components: {
    'wf-process-diagram': ProcessDiagram,
    'wf-process-info': ProcessInfo,
  },

  data() {
    return {
      canUnclaim: false,
      diagram: false,
      history: false,
      styleElement: null,
      subtitle: null,
      businessKey: null,
      processDefinitionName: null,
    }
  },

  computed: {
    ...mapGetters({
      task: 'task/task',
      variables: 'task/variables',
      style: 'task/style',
      loading: 'tools/loading',
      profile: 'auth/profile',
      confirm: 'tools/confirm',
      processInfoDialog: 'process/processInfoDialog',
    }),
  },

  watch: {
    'task.assignee'() {
      this.getSubtitle()
    },
  },

  created() {
    this.init()
    window.scrollTo(0, 0)
  },

  beforeRouteUpdate() {
    this.init()
  },

  beforeDestroy() {
    if (this.styleElement) {
      document.head.removeChild(this.styleElement)
    }
  },

  methods: {
    ...mapActions({
      claim: 'task/claim',
      unclaim: 'task/unclaim',
      setSnackbar: 'tools/setSnackbar',
      back: 'task/back',
      toggleProcessInfoDialog: 'process/toggleProcessInfoDialog',
    }),

    getTitle() {
      return this.processDefinitionName
    },

    getSubtitle() {
      const assignee = this.task.assignee ? this.task._embedded.user.find(x => x.id === this.task.assignee) : null
      const assigneeName = assignee && assignee.id !== this.profile.userName ? `<span class='text--primary' style="font-weight: 400;">${assignee.firstName} ${assignee.lastName}</span> - ` : ''
      this.subtitle = `${assigneeName}${this.$tf(`${this.task.processDefinitionId.split(':')[0]}._process.task.${this.task.taskDefinitionKey}`, this.task.name)}`
    },

    copyBusinessKey() {
      this.$copyText(this.businessKey)
      this.setSnackbar(this.$tf('task.businessKeyCopied'))
    },

    init() {
      if (this.style) {
        this.styleElement = document.createElement('style')
        this.styleElement.type = 'text/css'
        this.styleElement.innerText = this.style
        document.head.appendChild(this.styleElement)
      }

      this.businessKey = this.variables._businessKey ? this.variables._businessKey.value : null
      const pdnFallback = this.task._embedded.processDefinition.find(x => x.id === this.task.processDefinitionId).name
      this.processDefinitionName = this.$tf(`${this.task.processDefinitionId.split(':')[0]}._process.name`, pdnFallback)
      this.canUnclaim = lodash.some(this.task._embedded.identityLink, { type: 'candidate' })
      this.getSubtitle()
    },

    selectProcess(processId) {
      this.$refs.processInfo.show(processId)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.processInfoDialog) {
      this.toggleProcessInfoDialog(false)
      next(false)
    } else {
      next(true)
    }
  },
}
</script>

<style lang="stylus">
.btn-center {
  z-index 3
  position absolute !important
  top 200px
  left 50%
  transform translate(-50%, -50%)
}

full-height-desktop {
  height: calc(100vh - 90px);
}

.full-height-mobile {
  height: calc(100vh - 50px);
}

.v-card.task {
  display: flex !important;
  flex-direction: column;
}

//.v-card.task .v-card__text {
//  flex-grow: 1;
//  overflow-y: scroll;
//  overflow-x: hidden;
//}

.task-toolbar-title .v-avatar {
  vertical-align: text-bottom;
}
.task-toolbar-title ul {
  list-style: none;
  display: inline-block;
  padding-left: 18px;
}
.task-toolbar-title ul li {
  line-height: 20px;
  font-size: 16px;
}  
</style>



// WEBPACK FOOTER //
// src/components/task/TaskTemplate.vue